import { render, staticRenderFns } from "./Cost.vue?vue&type=template&id=f04db22a&scoped=true&"
import script from "./Cost.vue?vue&type=script&lang=js&"
export * from "./Cost.vue?vue&type=script&lang=js&"
import style0 from "./Cost.vue?vue&type=style&index=0&id=f04db22a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04db22a",
  null
  
)

export default component.exports